import { Button } from "@babackapp/ui/components/button";
import { FormField } from "@babackapp/ui/components/form";
import { TrashIcon } from "lucide-react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { OpeningTimesDay, StoreFormValues } from "./types";
import useTranslation from "@babackapp/translations/use-translation";
import FormInput from "@babackapp/react-hook-forms-components/form-input";

type OpeningTimesRangesFormProps = {
  day: OpeningTimesDay;
  closeEditor: () => void;
};

export default function OpeningTimesRangesForm({
  day,
  closeEditor,
}: OpeningTimesRangesFormProps) {
  const t = useTranslation();
  const { control } = useFormContext<StoreFormValues>();

  const ranges = useFieldArray({
    control,
    name: `openingTimes.${day}`,
  });

  const onKeydown = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      return closeEditor();
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {ranges.fields.length === 0 && (
        <span className="text-xs block text-muted-foreground">
          {t("settings.shop.physic.fields.closedAllDay")}
        </span>
      )}
      {ranges.fields.map((_, index) => (
        <div className="flex gap-2 items-end justify-end" key={index}>
          <FormField
            control={control}
            name={`openingTimes.${day}.${index}.from`}
            render={({ field }) => (
              <FormInput
                label={t("settings.shop.physic.fields.opening.title")}
                onKeyDown={onKeydown}
                {...field}
              />
            )}
          />
          <FormField
            control={control}
            name={`openingTimes.${day}.${index}.to`}
            render={({ field }) => (
              <FormInput
                label={t("settings.shop.physic.fields.closing.title")}
                onKeyDown={onKeydown}
                {...field}
              />
            )}
          />
          <Button variant="secondary" onClick={() => ranges.remove(index)}>
            <TrashIcon className="size-4" />
          </Button>
        </div>
      ))}
      <Button
        size="sm"
        type="button"
        variant="secondary"
        onClick={() =>
          ranges.append({
            from: "00:00",
            to: "00:00",
          })
        }
      >
        {t("settings.shop.physic.fields.addRange")}
      </Button>
    </div>
  );
}
